module.exports = __webpack_public_path__ + "img/icon-dhl.d32ddc87.svg";